module.exports = __webpack_public_path__ + "img/code-solid.9a499b06.svg";